import { collection, doc } from "firebase/firestore";

const LFG_ROOT_SEGMENTS = ["lfg", "root"];
const FEEDBACK_ROOT_SEGMENTS = ["feedback", "root"];

const LFG_POSTS_SEGMENTS = [...LFG_ROOT_SEGMENTS, "posts"];
const LFG_CHATS_SEGMENTS = [...LFG_ROOT_SEGMENTS, "chats"];
const FEEDBACK_REPORTS_SEGMENTS = [...FEEDBACK_ROOT_SEGMENTS, "reports"];

export const lfgPostsCollection = (firestore) =>
  collection(firestore, ...LFG_POSTS_SEGMENTS);

export const lfgPostDoc = (firestore, postId) =>
  doc(firestore, ...LFG_POSTS_SEGMENTS, postId);

export const lfgChatsCollection = (firestore) =>
  collection(firestore, ...LFG_CHATS_SEGMENTS);

export const lfgChatDoc = (firestore, chatId) =>
  doc(firestore, ...LFG_CHATS_SEGMENTS, chatId);

export const lfgChatMessagesCollection = (firestore, chatId) =>
  collection(firestore, ...LFG_CHATS_SEGMENTS, chatId, "messages");

export const feedbackReportsCollection = (firestore) =>
  collection(firestore, ...FEEDBACK_REPORTS_SEGMENTS);
